import type { MaybeRefOrGetter } from 'vue';

/**
 * "1 facture impayée" / "{count} factures impayées" label shared by the unpaid
 * banners, the hero card and the invoices panel (TDD-5601). Mirrors the
 * prototype's countLabel helper since the translation system has no plurals.
 */
export const useUnpaidCountLabel = (count: MaybeRefOrGetter<number>) => {
    const { t } = useTranslation();

    const countLabel = computed<string>(() => {
        const value = toValue(count);

        return value === 1 ? t('tenancy.tenant.unpaid.count_label_one') : t('tenancy.tenant.unpaid.count_label', { count: value });
    });

    const countLabelCapitalized = computed<string>(() => countLabel.value.charAt(0).toUpperCase() + countLabel.value.slice(1));

    return { countLabel, countLabelCapitalized };
};
